import { render, staticRenderFns } from "./KawaiiCamera.vue?vue&type=template&id=0227d747&scoped=true&"
import script from "./KawaiiCamera.vue?vue&type=script&lang=ts&"
export * from "./KawaiiCamera.vue?vue&type=script&lang=ts&"
import style0 from "./KawaiiCamera.vue?vue&type=style&index=0&id=0227d747&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0227d747",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VRow})
